export interface IMapMarkerBaseEvents {
  click: any;
  hover: any;
}
